import React from 'react';
import { Container, Row } from 'reactstrap';
import ActivityManagementTable from './components/ActivityManagementTable';
import PageHeader from '../../../shared/components/PageHeader';

const ActivityManagementTablePage = () => (
  <Container>
    <Row>
      <PageHeader title="Activity Manager" subhead="Activity Items By Date Descending" />
    </Row>
    <Row>
      <ActivityManagementTable />
    </Row>
  </Container>
);

export default ActivityManagementTablePage;

